import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import { CSS_MQ } from "../../../styles/breakpoints";
import React from "react";
import { NoImageSvg } from "../../../assets";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { ContentfulImage } from "../../../components/_shared-components/image-related/ContentfulImage";

export const PictureElement: ReactTFC<{
  asset?: string;
}> = props => {
  return (
    <div css={styles} className={"_picture"}>
      {props.asset ? (
        <ContentfulImage
          assetId={undefined}
          contentfulLink={{
            url: props.asset,
            noTransparentBackground: true,
            requestedWidth: 600,
          }}
          alt={""}
          css={css`
            max-width: 100%;
            max-height: 100%;
          `}
        />
      ) : (
        <NoImageSvg
          strokeWidth={3}
          css={css`
            color: ${CSS_COLORS.GrayDark2024};

            width: 60px;
          `}
        />
      )}
    </div>
  );
};

const styles = css`
  max-width: 100%;
  align-self: center;
  justify-self: center;

  display: flex;
  justify-content: center;
  align-items: center;

  picture {
    max-width: 100%;
    height: 100%;
  }

  height: 160px;
  max-height: 100%;
  width: 100%;
  ${CSS_MQ.atLeastMd} {
    height: 260px;
    width: 100%;
  }
`;
